import useComponentWillMount from './useComponentWillMount';
export default useComponentWillMount;
